import React, { useState } from 'react';
import { IaFacade } from '../../facades/IaFacade';
import Sidebar from '../Sidebar'; // Ajuste o caminho se necessário

export const BuscaIa: React.FC = () => {
    // Mantemos os estados prontos para quando a IA for ativada
    const [pergunta, setPergunta] = useState('');
    const [resposta, setResposta] = useState('');
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState<string | null>(null);

    const handleBuscar = async (e: React.FormEvent) => {
        e.preventDefault();
        // A lógica de busca está preservada aqui para o futuro
    };

    return (
        <Sidebar>
            <header className="mb-8">
                <div className="flex items-center gap-3">
                    <h2 className="text-3xl font-extrabold text-gray-800">Busca Inteligente (RAG)</h2>
                    <span className="bg-yellow-100 text-yellow-800 text-xs font-bold px-3 py-1 rounded-md border border-yellow-200 mt-1">
                        Em implementação...
                    </span>
                </div>
                <p className="text-gray-500 mt-2">Faça perguntas em linguagem natural sobre os processos indexados.</p>
            </header>

            <div className="bg-white p-6 rounded-lg shadow-md max-w-5xl">
                <form onSubmit={handleBuscar}>
                    {/* Formulário Bloqueado (Opacidade e Cursor Alterados) */}
                    <div className="opacity-60 cursor-not-allowed">
                        <div className="mb-4">
                            <label htmlFor="pergunta" className="block text-sm font-bold text-gray-700 mb-2">
                                Sua Pergunta
                            </label>
                            <textarea
                                id="pergunta"
                                rows={4}
                                value={pergunta}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed resize-none focus:outline-none focus:ring-0"
                                placeholder="Ex: Quais processos mencionam 'vício de construção' e estão aguardando perícia?"
                                disabled
                                readOnly
                            />
                        </div>
                        <button
                            type="button" // Alterado temporariamente para "button" para não acionar submits acidentais
                            disabled
                            className="w-full bg-blue-800 text-white font-bold py-3 px-4 rounded-lg cursor-not-allowed transition-colors"
                        >
                            Buscar
                        </button>
                    </div>
                </form>

                {/* Aviso Explicativo de UX */}
                <div className="mt-8 flex items-start gap-3 p-4 bg-blue-50 text-blue-800 rounded-lg border border-blue-100">
                    <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-sm">
                        <strong>Aviso:</strong> A integração com a API da nossa IA (Claude) está sendo finalizada. Em breve, você poderá extrair informações complexas e cruzadas de toda a sua base de dados apenas fazendo perguntas naturais.
                    </p>
                </div>
            </div>
        </Sidebar>
    );
};